import PromisedResource from './PromisedResource'

export default class FieldsResource extends PromisedResource {
  constructor(remote, parentRecord) {
    super(remote.query(q => q.findRelatedRecords(parentRecord, 'fields')))
  }
}
